import React from 'react';

const ActivePage = ({ page }) => <div className="artp-ui-pagination-active-page">{page}</div>;

export default ActivePage;
